module.exports = __webpack_public_path__ + "img/agoda-logo.e55e6fa6.svg";